import { render, staticRenderFns } from "./LabelRaw.vue?vue&type=template&id=7a7467d6&scoped=true"
import script from "./LabelRaw.vue?vue&type=script&lang=js"
export * from "./LabelRaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7467d6",
  null
  
)

export default component.exports